import styles from './ListedTag.module.scss';
import { Tooltip } from '@bfe/moly';
import Image from 'next/image';
import { HELP_ICON } from '@/constants';
import { isMobile } from '@web3/base-utils';
import { WAVE_NUM } from './types';
import { NoSSR } from '@web3/base-components';
import clx from 'classnames';
import { useFm } from '@web3/base-hooks';

const ToolTipContent = ({
  title,
  text,
}: {
  title: string;
  text: React.ReactNode;
}) => {
  return (
    <div className={styles.tip}>
      <Image
        className={clx(styles.icon, {
          [styles.mobile]: isMobile,
        })}
        loader={({ src }) => src}
        src={HELP_ICON}
        width={16}
        height={16}
        alt=""
      />
      <div className={styles.content}>
        {!isMobile && <h1 className={styles.title}>{title}</h1>}
        <p className={styles.text}>{text}</p>
      </div>
    </div>
  );
};

/**
 * 注意, Tooltip 在 next 的 SSR 场景下使用,需要排除 SSR 渲染
 * @source https://moly.fe.bybit.com/components/tooltip
 */
const ListedTag = ({ tagText }: { tagText?: React.ReactNode }) => {
  const fm = useFm();

  // const genTagText = (waveNum: WAVE_NUM, names: string[]) => {
  //   if (waveNum === WAVE_NUM.ONE) {
  //     return fm('projectLiveOnBybitSpot1', {
  //       projectName: names?.[0],
  //     });
  //   }
  //   return fm('projectLiveOnBybitSpot2', {
  //     projectName1: names[0],
  //     projectName2: names[1],
  //     projectName3: names[2],
  //   });
  // };
  const title = fm('winningDebutTeam');
  // const text = genTagText(waveNum, names);

  return (
    <div
      className={clx(styles.listedTag, {
        [styles.mobile]: isMobile,
      })}
      onClick={(e) => e.stopPropagation()}
    >
      <NoSSR>
        <Tooltip title={<ToolTipContent text={tagText} title={title} />}>
          <span
            className={clx(styles.outerTitle, {
              [styles.mobile]: isMobile,
            })}
          >
            {title}
          </span>
        </Tooltip>
      </NoSSR>
    </div>
  );
};

export default ListedTag;
